const getPreviousValue = set => {
  const values = Array.from(set);
  return values.length > 1 ? values[values.length - 2] : undefined;
};

export default getPreviousValue;
